/**
 * IUPAC 塩基照合（§5.4 I54）。コード列（A=0 C=1 G=2 T=3 N=4）と記号をビットで合わせる。
 */

import { CODE_A, CODE_C, CODE_G, CODE_N, CODE_T, NUCLEOTIDE_CODE_COUNT } from '../sequence/nucleotideCodes';

const BIT_A = 1;
const BIT_C = 2;
const BIT_G = 4;
const BIT_T = 8;
const BIT_N = BIT_A | BIT_C | BIT_G | BIT_T;

const CODE_BITS = [BIT_A, BIT_C, BIT_G, BIT_T, BIT_N];

const SYMBOL_BITS: Record<string, number> = {
  A: BIT_A,
  C: BIT_C,
  G: BIT_G,
  T: BIT_T,
  U: BIT_T,
  R: BIT_A | BIT_G,
  Y: BIT_C | BIT_T,
  S: BIT_G | BIT_C,
  W: BIT_A | BIT_T,
  K: BIT_G | BIT_T,
  M: BIT_A | BIT_C,
  B: BIT_C | BIT_G | BIT_T,
  D: BIT_A | BIT_G | BIT_T,
  H: BIT_A | BIT_C | BIT_T,
  V: BIT_A | BIT_C | BIT_G,
  N: BIT_N,
};

export const IUPAC_ALPHABET = 'ACGTURYSWKMBDHVN';

export function iupacBits(symbol: string): number | null {
  if (symbol.length !== 1) return null;
  return SYMBOL_BITS[symbol.toUpperCase()] ?? null;
}

export function encodeIupacPattern(pattern: string): Uint8Array | null {
  const bits = new Uint8Array(pattern.length);
  for (let i = 0; i < pattern.length; i += 1) {
    const value = iupacBits(pattern[i]);
    if (value === null) return null;
    bits[i] = value;
  }
  return bits;
}

export function codeMatchesIupac(code: number, symbolBits: number): boolean {
  const bits = code < NUCLEOTIDE_CODE_COUNT ? CODE_BITS[code] : BIT_N;
  return (bits & symbolBits) !== 0;
}

/** 相補 IUPAC（向きはそのまま。逆相補は呼び出し側で反転） */
export function complementIupacSymbol(symbol: string): string {
  const map: Record<string, string> = {
    A: 'T',
    T: 'A',
    U: 'A',
    C: 'G',
    G: 'C',
    R: 'Y',
    Y: 'R',
    S: 'S',
    W: 'W',
    K: 'M',
    M: 'K',
    B: 'V',
    V: 'B',
    D: 'H',
    H: 'D',
    N: 'N',
  };
  return map[symbol.toUpperCase()] ?? 'N';
}

export function reverseComplementIupac(pattern: string): string {
  let out = '';
  for (let i = pattern.length - 1; i >= 0; i -= 1) {
    out += complementIupacSymbol(pattern[i]);
  }
  return out;
}
